import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "transparent",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 9L12 15L18 9",
		stroke: "#596180",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "transparent"
	})
});
export default SvgChevronDown;
